import { initAllTestimonialsSwipers } from './init-testimonials-swiper';

function boot() {
	initAllTestimonialsSwipers();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
